import React from "react";
import { Helmet } from "react-helmet";

const HomeSEO = () => {
  return (
     
      <Helmet>
        <title>Betpro Plus - Best Online Betting Platform in Pakistan</title>
        <link rel="icon" href="https://betprowallet.pk/favicon.ico" />

  
   <link rel="canonical" href="https://betprowallet.pk/home" />

        <meta name="description" content="Betpro Plus is the best online betting platform in Pakistan. ⚽️ Sign up for free, bet on sports, and get a sign-up bonus. ✅ Easy deposits, secure withdrawals, and win big today at Betprowallet.pk." />
        <meta name="keywords" content="Betpro Plus, online betting in Pakistan, sports betting, Betpro Plus Pakistan, best betting platform, Betpro Plus registration, Betpro Plus sign up bonus, Betprowallet.pk" />
        <meta name="author" content="Betpro Plus" />
        <meta property="og:title" content="Betpro Plus - Best Online Betting Platform in Pakistan" />
        <meta property="og:description" content="Join Betpro Plus, Pakistan's most trusted betting platform. Bet on sports, enjoy bonuses, and win big with safe and easy transactions." />
        <meta property="og:url" content="https://betprowallet.pk.home" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://betprowallet.pk/bpthumb1.jpg" />

       
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "Website",
              "name": "Betpro Plus - Best Online Betting Platform in Pakistan",
              "url": "https://betprowallet.pk/home",
              "description": "Betpro Plus is the leading online betting platform in Pakistan. Sign up today and get a welcome bonus to start betting on your favorite sports.",
              "publisher": {
                "@type": "Organization",
                "name": "Betpro Plus"
              }
            }
          `}
        </script>
      </Helmet>

  );
};

export default HomeSEO;
